<template>
    <div v-if="user.about" class="profile-about-description" :class="descriptionOpen === true ? 'profile-about-description--open': '' ">
        <div class="profile-about-description__header">
            О волонтере
        </div>
        <div class="profile-about-description__body">
            <div class="profile-about-description__body-content" v-text="user.about"></div>
            <a v-if="user.about.length > 354" href="#" class="profile-about-description__body-more" @click.prevent="descriptionOpen = !descriptionOpen">Скрыть</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserDescription",
    props: ['user'],
    data(){
        return{
            descriptionOpen: false,
        }
    },
}
</script>

<style scoped>

</style>
